import { render } from "./ZoomToLanguage.component.vue?vue&type=template&id=5b142c9c"
import script from "./ZoomToLanguage.component.vue?vue&type=script&lang=js"
export * from "./ZoomToLanguage.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__